import React from 'react';
import ReactDOM from 'react-dom';
import "./assets/scss/style.scss";
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
